import SelectBox from "components/Common/SelectBox"
import React, { useEffect, useState } from "react"
import { Col, Input, Label, Row, Table } from "reactstrap"
import SizeTable from "./SizeTable"
import DateInput from "components/Common/DateInput"
import { getRTWProductIdsApi } from "helpers/corporate_orders_create_resources"

export default function OrderDetails(props) {
  const {
    config: {
      data,
      onSizeChange,
      onCompletedInspectChange,
      onReducedProdChange,
    },
  } = props
  const {
    supplierName,
    picName,
    orderDate,
    year,
    seasonId,
    seasonName,
    productId,
    productName,
    newProduct,
    sample,
    scheduledDeliveryDate,
    orderNumber,
    type,
  } = data

  const [productIds, setProductIds] = useState([])

  const loadProductIds = async () => {
    try {
      const { data } = await getRTWProductIdsApi()
      const _productIds = data.map(item => ({
        value: item.id,
        label: `${item.number} - ${item.name}`,
      }))
      setProductIds(_productIds)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    loadProductIds()
  }, [])

  return (
    <Row>
      <Col xl={4} sm={4}>
        <p>RTW受注詳細</p>
        <Table bordered>
          <tbody>
            <tr>
              <th style={{ width: 135 }}>お取引先様</th>
              <td>
                <SelectBox
                  options={[]}
                  value={{
                    label: supplierName,
                    value: supplierName,
                  }}
                  isDisabled={true}
                />
              </td>
            </tr>
            <tr>
              <th>ご担当者さま</th>
              <td>
                <Input type="text" value={picName} readOnly disabled />
              </td>
            </tr>
            <tr>
              <th>年度</th>
              <td>
                <SelectBox
                  options={[]}
                  value={{
                    label: year,
                    value: year,
                  }}
                  isDisabled={true}
                />
              </td>
            </tr>
            <tr>
              <th>シーズン</th>
              <td>
                <SelectBox
                  options={[]}
                  value={{
                    label: seasonName,
                    value: seasonId,
                  }}
                  isDisabled={true}
                />
              </td>
            </tr>
            <tr>
              <th>注文日</th>
              <td>
                <DateInput
                  value={orderDate}
                  disabled
                  className="form-control"
                />
              </td>
            </tr>
            <tr>
              <th>納品予定日</th>
              <td>
                <DateInput
                  value={scheduledDeliveryDate}
                  disabled
                  className="form-control"
                />
              </td>
            </tr>
            <tr>
              <th>発注書No.</th>
              <td>
                <Input type="text" value={orderNumber} readOnly disabled />
              </td>
            </tr>
            <tr>
              <th>発注種類</th>
              <td className="d-flex flex-column">
                <div>
                  <Input
                    name="orderType"
                    id="アトリエメイド"
                    value="アトリエメイド"
                    type="radio"
                    className="me-2"
                    checked={type === "アトリエメイド"}
                    disabled
                    readOnly
                  />
                  <Label htmlFor="アトリエメイド">アトリエメイド</Label>
                </div>
                <div>
                  <Input
                    name="orderType"
                    id="ファクトリーメイド"
                    value="ファクトリーメイド"
                    type="radio"
                    className="me-2"
                    checked={type === "ファクトリーメイド"}
                    disabled
                    readOnly
                  />
                  <Label htmlFor="ファクトリーメイド">ファクトリーメイド</Label>
                </div>
              </td>
            </tr>
          </tbody>
        </Table>
      </Col>
      <Col xl={8} sm={8}>
        {/* <div className="d-flex justify-content-end">
          <div className="d-flex gap-4">
            {status !== "出荷完了" && (
              <SButton className="button" onClick={onShipping}>
                出荷
              </SButton>
            )}

            {type !== "アトリエメイド" && (
              <SButton className="button" onClick={onBulkClick}>
                一括納品
              </SButton>
            )}

            <SButton className="button" onClick={() => onSubmit(true)}>
              保存
            </SButton>
            
            <BackButton className="button" />            
          </div>
        </div> */}
        <Label htmlFor="productId">商品番号を選択してください</Label>
        <Row className="mb-3">
          <Col sm={4}>
            <SelectBox
              options={productIds}
              value={productIds.filter(p => p.value === productId)}
              id="productId"
              isDisabled={true}
            />
          </Col>
          <Col
            className="d-flex justify-content-center align-items-center"
            sm={2}
          >
            <div className="d-flex">
              <Input
                type="checkbox"
                checked={newProduct}
                disabled
                readOnly
                className="me-2"
                id="新規商品"
              />
              <Label htmlFor="新規商品">新規商品</Label>
            </div>
          </Col>
          <Col>
            <Input
              type="text"
              placeholder="商品名"
              value={newProduct ? productName : ""}
              readOnly
              disabled
            />
          </Col>
        </Row>

        <Table bordered className="mt-3">
          <tbody>
            <tr>
              <td style={{ width: 105 }}>サンプル</td>
              <td>
                <Input
                  id="サンプル"
                  type="checkbox"
                  checked={sample}
                  className="me-2"
                  readOnly
                  disabled
                />
                <Label htmlFor="サンプル"> サンプル</Label>
              </td>
            </tr>
          </tbody>
        </Table>

        <SizeTable
          sizes={data.sizes}
          onSizeChange={onSizeChange}
          type={type}
          onCompletedInspectChange={onCompletedInspectChange}
          onReducedProdChange={onReducedProdChange}
          onSubmit={onsubmit}
          config={props.config}
        />
      </Col>
    </Row>
  )
}
